// src/authService.js
import api from './api'; // Use your shared Axios instance

const BASE_URL = '/api/auth/';

export const logInWithEmailAndPassword = async (email, password, visitorId, sessionId) => {
  // Use provided parameters, fallback to localStorage if not provided
  const finalVisitorId = visitorId || localStorage.getItem('visitorId');
  const finalSessionId = sessionId || localStorage.getItem('sessionId');
  
  // Include name and reason from localStorage for auto-registration support
  const name = localStorage.getItem('guestName') || '';
  const reason = localStorage.getItem('userReason') || '';

  const response = await api.post(`${BASE_URL}login/`, {
    email,
    password,
    visitor_id: finalVisitorId,
    session_id: finalSessionId,
    name,
    reason,
  });

  const token = response.data.key;
  localStorage.setItem('authToken', token);
  api.defaults.headers.common['Authorization'] = `Token ${token}`;

  return response.data; // Return full response data (includes key, user, and created flag)
};

export const registerWithEmail = async (
  email,
  password1,
  password2,
  visitorId,
  captchaToken,
  sessionId
) => {
  try {
    // Use email as username for consistency (backend will normalize it)
    const username = email.trim().toLowerCase();
    const name = localStorage.getItem('guestName') || '';
    const reason = localStorage.getItem('userReason') || '';

    const response = await api.post(`${BASE_URL}registration/`, {
      username,
      email,
      password1,
      password2,
      visitor_id: visitorId,
      captcha: captchaToken,
      session_id: sessionId,
      name,
      reason,
    });

    const token = response.data.key;
    localStorage.setItem('authToken', token);
    api.defaults.headers.common['Authorization'] = `Token ${token}`;
    return response.data; // Return full response data (includes key and user)
  } catch (error) {
    console.error('Registration error:', error.response?.data || error.message);
    throw error;
  }
};

export const createUserProfile = async (data) => {
  const token = localStorage.getItem('authToken');
  const response = await api.post('/api/profile/', data, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });
  return response.data;
};

export function googleLogin(id_token, name, reason) {
  const visitor_id = localStorage.getItem('visitorId');
  return api.post('/auth/google/', {
    id_token,
    visitor_id,
    name,
    reason,
  });
}